"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginatedResponseSchema = exports.paginationSchema = void 0;
const zod_1 = require("zod");
/**
 * Pagination input schema
 * Supports offset-based pagination with configurable limits
 */
exports.paginationSchema = zod_1.z.object({
    limit: zod_1.z.number().int().min(1).max(100).default(50).optional(),
    offset: zod_1.z.number().int().min(0).default(0).optional(),
});
/**
 * Paginated response wrapper
 */
const paginatedResponseSchema = (dataSchema) => zod_1.z.object({
    data: zod_1.z.array(dataSchema),
    pagination: zod_1.z.object({
        limit: zod_1.z.number(),
        offset: zod_1.z.number(),
        total: zod_1.z.number(),
        hasMore: zod_1.z.boolean(),
    }),
});
exports.paginatedResponseSchema = paginatedResponseSchema;
